module.exports = __webpack_public_path__ + "img/browse-vehicles-background-lincoln.897b23e3.png";